module.exports = __webpack_public_path__ + "static/media/Hero_Image_Tablet_2.b0f96e0f.jpg";